<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="schedule_display_products"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_schedule_display_product_index_918')">
      <Form :model="schedule_display_product"
            :label-width="80">
        <Form-item :label="$t('pages_bookings_new_232')" prop="fresh_product_id">
          <el-select
            v-model="schedule_display_product.fresh_product_id"
            filterable
            remote
            :placeholder="$t('pages_combo_rule_list_291')"
            :remote-method="remoteMethod"
            >
            <el-option
              v-for="i in products"
              :value="i.id"
              :key="i.id"
              :label="i.name"
            >
            </el-option>
          </el-select>
        </Form-item>
        <Form-item :label="$t('pages_schedule_display_product_index_919')"
                   prop="start_hour_minute">
          <TimePicker format="HH:mm" :placeholder="$t('pages_enough_consume_discount_index_484')" v-model="schedule_display_product.start_hour_minute"></TimePicker>
        </Form-item>
        <Form-item :label="$t('pages_schedule_display_product_index_920')"
                   prop="end_hour_minute">
          <TimePicker format="HH:mm" :placeholder="$t('pages_enough_consume_discount_index_485')" v-model="schedule_display_product.end_hour_minute"></TimePicker>
        </Form-item>
        <Form-item :label="$t('pages_schedule_display_product_index_921')"
                   prop="is_running">
          <i-switch v-model="schedule_display_product.is_running" size="large">
            <span slot="open">{{$t('pages_birthday_discount_index_208')}}</span>
            <span slot="close">{{$t('pages_birthday_discount_index_209')}}</span>
          </i-switch>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable, booleanChinese, commonButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_schedule_display_product_index_922'),
          key: 'fresh_product_id'
        },
        {
          title: i18n.t('pages_schedule_display_product_index_919'),
          key: 'start_hour_minute'
        },
        {
          title: i18n.t('pages_schedule_display_product_index_920'),
          key: 'end_hour_minute'
        },
        {
          title: i18n.t('pages_schedule_display_product_index_921'),
          key: 'is_running',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(booleanChinese(
              h,
              params.row.is_running))
            return h('div', children)
          }
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 280,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            children.push(commonButtonInTable(this,
              h,
              'info',
              i18n.t('pages_schedule_display_product_index_923'),
              this.handleRun,
              [params.row]))
            return h('div', children)
          }
        }
      ],
      searchProducts: {
        query: ''
      },
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
    this.productIndex()
  },
  computed: {
    ...mapState('schedule_display_product', ['schedule_display_product', 'schedule_display_products', 'meta', 'loading']),
    ...mapGetters('product', ['products']),
  },
  methods: {
    ...mapActions('schedule_display_product', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'run'
    ]),
    ...mapMutations('schedule_display_product', ['changeQuery']),
    ...mapActions('product', {
      productIndex: 'index'
    }),
    ...mapMutations('product', {
      productChangeQuery: 'changeQuery',
      productResetQuery: 'resetQuery'
    }),
    async handleRun (params) {
      await this.run(params);
      await this.index()
    },
    remoteMethod (query) {
      if (query !== '') {
        this.searchProducts.query = query
        this.searchBtnClick()
      }
    },
    searchBtnClick () {
      this.productChangeQuery(this.searchProducts)
      this.productIndex()
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.schedule_display_product)
      } else if (this.formType === 'new') {
        await this.create(this.schedule_display_product)
      }
      this.modalShow = false
    },
  }
}
</script>
